import React from "react";
import SendNotificationForm from "./SendNotificationForm";

export default function NotificationPage() {
  return (
    <div style={{ maxWidth: 480, margin: "40px auto", background: "#181f2a", borderRadius: 16, boxShadow: "0 4px 32px #0002", padding: 32 }}>
      <h1 style={{ fontSize: 24, fontWeight: 800, marginBottom: 24, color: "#f59e0b" }}>Bildirim Gönder</h1>
      <SendNotificationForm />
    </div>
  );
}
